<mat-card>{{'productCardsInventory' | translate}}</mat-card>


<div class="container inventory-container">

    <div class="inventory-filters">
        <mat-form-field appearance="fill" class="filter-field filter-date-range">
            <mat-label>{{'enterDateRange' | translate}}</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker">
                <input matStartDate placeholder="Start date" #fromDate>
                <input matEndDate placeholder="End date" #toDate>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
                <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                    <button mat-raised-button color="primary" matDateRangePickerApply>{{'done' |
                        translate}}</button>
                </mat-date-range-picker-actions>
            </mat-date-range-picker>
        </mat-form-field>

        <mat-form-field appearance="fill" class="filter-field filter-time" floatLabel="always">
            <mat-label>{{'fromTime' | translate}}</mat-label>
            <input matInput type="time" [(ngModel)]="fromTime">
        </mat-form-field>

        <mat-form-field appearance="fill" class="filter-field filter-time" floatLabel="always">
            <mat-label>{{'toTime' | translate}}</mat-label>
            <input matInput type="time" [(ngModel)]="toTime">
        </mat-form-field>

        <mat-form-field appearance="fill" class="filter-field filter-category">
            <mat-label>{{'categoryType' | translate}}</mat-label>
            <mat-select [(value)]="selectedType">
                <mat-option *ngFor="let type of catgType" [value]="type.id">
                    {{type.name | translate}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="filter-actions">
            <button mat-raised-button color="primary" (click)="getCategoryInv()">
                <mat-icon>search</mat-icon>
                {{'filter' | translate}}
            </button>
            <button mat-raised-button color="primary" (click)="exportAsXLSX()" [disabled]="viewProductDetails ? productInventory.length == 0 : 
            viewSubCategoryDetails ? subCategoryInventory.length == 0 : categoryInventory.length == 0">
                <mat-icon>import_export</mat-icon>
                {{'exportExcel' | translate}}
            </button>
            <button mat-raised-button color="primary" (click)="back()"
                *ngIf="viewSubCategoryDetails || viewProductDetails">
                <mat-icon>keyboard_backspace</mat-icon>
                {{'back' | translate}}
            </button>
        </div>
    </div>


    <div class="mat-elevation-z8" *ngIf="!viewSubCategoryDetails && !viewProductDetails">
        <table mat-table [dataSource]="dataSource" matSort id="invCategoryTable">

            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'category' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.category}} </td>
                <td mat-footer-cell *matFooterCellDef>{{'total' | translate}}</td>
            </ng-container>

            <ng-container matColumnDef="addedCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'addedCount' | translate}} / {{'costPrice' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;">{{row.addedCount}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.addedCount_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalAddCountCategory()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalCostAddCountCategory()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="soldCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'soldCount' | translate}} / {{'costPrice' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;">{{row.soldCount}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.soldCount_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalSoldCountCategory()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalSoldCountCostCategory()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="unSoldCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'unsoldCount' | translate}} / {{'costPrice' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;">{{row.unSoldCount}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.unSoldCount_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalUnsoldCountCategory()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalUnSoldCostCategory()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="prevCountUnsold">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'prevCountUnsold' | translate}} / {{'costPrice' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;">{{row.prevCountUnsold}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.prevCountUnsold_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalPrevUnsoldCountCategory()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalPrevUnsoldCostCategory()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'details' | translate}} </th>
                <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
                    <button mat-raised-button color="primary" (click)="details(row)">
                        <mat-icon>save</mat-icon>
                        {{'details' | translate}}
                    </button>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
            </tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
        </table>

        <mat-paginator #paginatorCategory="matPaginator" [pageSize]="pageSizeCategory"
            [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

    <div class="mat-elevation-z8" *ngIf="viewSubCategoryDetails">
        <table mat-table [dataSource]="dataSourceSubCategory" matSort id="invSubCategoryTable">

            <ng-container matColumnDef="subCategory">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'subCategory' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.subCategory}} </td>
                <td mat-footer-cell *matFooterCellDef>{{'total' | translate}}</td>
            </ng-container>

            <ng-container matColumnDef="addedCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'addedCount' | translate}} / {{'costPrice' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;">{{row.addedCount}} </span> /
                    <span style="color: rgb(201, 111, 27);">{{row.addedCount_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalAddCountSubCategory()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalCostAddCountSubCategory()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="soldCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'soldCount' | translate}} / {{'costPrice' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;">{{row.soldCount}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.soldCount_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalSoldCountSubCategory()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalSoldCountCostSubCategory()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="unSoldCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'unsoldCount' | translate}} / {{'costPrice' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;"> {{row.unSoldCount}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.unSoldCount_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalUnsoldCountSubCategory()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalUnSoldCostSubCategory()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="prevCountUnsold">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'prevCountUnsold' | translate}} / {{'costPrice' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;">{{row.prevCountUnsold}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.prevCountUnsold_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalPrevUnsoldCountSubCategory()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalPrevUnsoldCostSubCategory()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'details' | translate}} </th>
                <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
                    <button mat-raised-button color="primary" (click)="detailsSubCategory(row)">
                        <mat-icon>save</mat-icon>
                        {{'details' | translate}}
                    </button>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsSubCategory"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsSubCategory;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
            </tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumnsSubCategory; sticky: true"></tr>
        </table>

        <mat-paginator #paginatorSubCategory="matPaginator" [pageSize]="pageSizeSubCategory"
            [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

    <div class="mat-elevation-z8" *ngIf="viewProductDetails">
        <table mat-table [dataSource]="dataSourceProduct" matSort id="invProductTable">

            <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'product' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{subCategoryName}} - {{row.product}} </td>
                <td mat-footer-cell *matFooterCellDef>{{'total' | translate}}</td>
            </ng-container>

            <ng-container matColumnDef="addedCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'addedCount' | translate}} / {{'costPrice' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;">{{row.addedCount}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.addedCount_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalAddCountProduct()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalCostAddCountProduct()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="soldCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'soldCount' | translate}} / {{'costPrice' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;">{{row.soldCount}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.soldCount_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalSoldCountProduct()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalSoldCountCostProduct()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="unSoldCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'unsoldCount' | translate}} / {{'costPrice' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;"> {{row.unSoldCount}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.unSoldCount_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalUnsoldCountProduct()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalUnSoldCostProduct()}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="prevCountUnsold">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{'prevCountUnsold' | translate}} / {{'costPrice' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                    <span style="color: #a500a2;">{{row.prevCountUnsold}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{row.prevCountUnsold_costPrice}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                    <span style="color: #a500a2;">{{getTotalPrevUnsoldCountProduct()}}</span> /
                    <span style="color: rgb(201, 111, 27);">{{getTotalPrevUnsoldCostProduct()}}</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsProduct"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsProduct;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
            </tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumnsProduct; sticky: true"></tr>
        </table>

        <mat-paginator #paginatorProduct="matPaginator" [pageSize]="pageSizeProduct"
            [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>




<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>